export const fileupload = {
  root: {
    borderColor: 'colors.transparent',
  },
  header: {
    padding: '18px 0 0 0',
  },
  file: {
    info: {
      gap: '1em',
    },
    padding: '0',
  },
};
